import _ from 'lodash'
import Mustache from 'mustache'
import { Suspense } from 'react'

import BIMESSAGES from 'core/data-model/constants/bi-messages'
import MESSAGES from 'core/data-model/constants/messages'
import { renderBIAge } from 'core/service/insured/age'
import { christianToThaiDate } from 'core/service/lib/date'
import { formatNumber } from 'core/service/lib/number-format'
import { hasAsteriskFromRiders } from 'core/service/rider/benefits/benefit-data'
import { getServiceWrapper } from 'core/service-wrapper'

import SummaryTable from './summary-table'

const renderGraph = (basicPlanCode) => {
  const serviceWrapper = getServiceWrapper()
  const className = `graph-${basicPlanCode}`
  return (
    <Suspense fallback={null}>
      {(() => {
        switch (basicPlanCode) {
          case 'LR05':
            return serviceWrapper.renderGraph('LR05', className)
        }
      })()}
    </Suspense>
  )
}

const ProfileSnapshot = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  policyValue,
  sumAssured,
  basicPremium,
  totalPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  hasShowDisclaimerRiderAsterisk,
  totalRiderPremium,
  profileSummaryHeader,
  summaryTableHeader,
  showGraph = true,
  isNewAsteriskOfSummaryMainContract,
  isReviseQQ,
  isCheckHaveRiderCampaignDiscountActive,
  riderCampaignDiscountBIMessage,
}) => {
  return (
    <div id="profile-summary" className="snapshot group">
      <h2>
        {_.isFunction(profileSummaryHeader)
          ? // $$FlowFixMe
            profileSummaryHeader({
              displayProduct,
              riders,
              genderLabel,
              age,
              calculatedCoveragePeriod,
              calculatedPaymentPeriod,
              sumAssured,
              basicPremium,
              totalPremium,
              selectedModelFactorLabel,
              hasNonLevelRider,
              totalRiderPremium,
            })
          : profileSummaryHeader}
      </h2>
      <div className="profile">
        <div className="info gender">
          <p className="label">{MESSAGES.GENDER}</p>
          <p className="value">{genderLabel}</p>
        </div>
        <div className="info age">
          <p className="label">{MESSAGES.AGE}</p>
          <p className="value">{renderBIAge(age, isReviseQQ)}</p>
        </div>
        <div className="info coverage-period">
          <p className="label">{BIMESSAGES.COVERAGE_PERIOD}</p>
          <p className="value">{BIMESSAGES.COVERAGE_PERIOD_RETIREMENT_SUFFIX}</p>
        </div>
        <div className="info payment-period">
          <p className="label">{BIMESSAGES.PREMIUM_PAYMENT_PERIOD}</p>
          <p className="value">
            {calculatedPaymentPeriod} {MESSAGES.TIME_UNIT_YEAR}
          </p>
        </div>
      </div>
      <div className="coverage">
        <div className="info sum-assured">
          <p className="label">{BIMESSAGES.BASIC_PLAN_SUM_ASSURED}</p>
          <p className="value">
            {formatNumber(sumAssured)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info model-factor">
          <p className="label">{MESSAGES.PAYMENT_MODE}</p>
          <p className="value">{selectedModelFactorLabel}</p>
        </div>
      </div>
      <div className="coverage">
        <div className="info basic-premium">
          <p className="label">{BIMESSAGES.BASIC_PREMIUM}</p>
          <p className="value">
            {formatNumber(basicPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        <div className="info rider-premium">
          <p className="label">
            {BIMESSAGES.TOTAL_RIDER_PREMIUM}
            {hasAsteriskFromRiders(riders) ? '*' : ''}
          </p>
          <p className="value">
            {formatNumber(totalRiderPremium, 2)} {MESSAGES.BAHT}
            {/*{totalRiderPremium(riders)}*/}
          </p>
        </div>
        <div className="info total-premium">
          <p className="label">{BIMESSAGES.TOTAL_PREMIUM_FIRST_PREMIUM}</p>
          <p className="value">
            {formatNumber(totalPremium, 2)} {MESSAGES.BAHT}
          </p>
        </div>
        {isCheckHaveRiderCampaignDiscountActive && riderCampaignDiscountBIMessage.length > 0
          ? riderCampaignDiscountBIMessage.map((riderMsg, index) => {
              return (
                <div key={index} className="rider-campaign-discount-message">
                  {riderMsg}
                </div>
              )
            })
          : ''}
      </div>
      {showGraph && displayProduct ? renderGraph(displayProduct.basicPlanCode) : ''}
      <SummaryTable
        displayProduct={displayProduct}
        riders={riders}
        age={age}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        basicPremium={basicPremium}
        totalPremium={totalPremium}
        basicSumAssured={sumAssured}
        hasNonLevelRider={hasNonLevelRider}
        hasShowDisclaimerRiderAsterisk={hasShowDisclaimerRiderAsterisk}
        summaryTableHeader={summaryTableHeader}
        isNewAsteriskOfSummaryMainContract={isNewAsteriskOfSummaryMainContract}
      />
    </div>
  )
}

export default ProfileSnapshot
